<template>
  <ModalSlotted @close="$emit('closed')">
    <header slot="header">
      <h1>Confirmação</h1>
    </header>
    <div slot="body">
      {{ message }}
    </div>
    <footer slot="footer">
      <button :disabled="saving" @click="$emit('closed')" class="ml-auto btn">Cancelar</button>
      <button :disabled="saving" @click="$emit('closed', true)" class="ml-2 btn btn--primary">Confirmar</button>
    </footer>
  </ModalSlotted>
</template>

<script>
export default {
  name: 'ModalConfirm',
  props: {
    message: {
      type: String,
      default: 'Confirma a ação?'
    }
  }
}
</script>
